<template>
  <the-page :pageId="pageId">
    <div class="main-page">
      <div class="main-page__content">
        <div class="main-page__block">
          <div class="main-page__block-logo">
            <div class="main-page__emblem"></div>

            <div class="main-page__block-logo-text">
              <p class="main-page__text-header_blue">росстат</p>

              <p class="main-page__text">большие данные</p>
            </div>
          </div>

          <p class="main-page__block-text_big">Информационная система по сбору больших данных</p>

          <p class="main-page__block-text_small">
            из различных источников для использования их в расчетах индекса потребительских цен и
            статистики торговли
          </p>

          <p class="main-page__version">версия системы: {{ version }}</p>
          <p class="main-page__role">роль: {{menuRole}}</p>
        </div>

        <div class="main-page__block">
          <p class="main-page__text-header_black">
            {{ name }}, <br />
            добро пожаловать!
          </p>

          <!--          <p class="main-page__text">-->
          <!--            Дата последнего посещения: 22.07.2021-->
          <!--            <span class="main-page__time">11:33</span>-->
          <!--          </p>-->

          <a-button class="main-page__btn" type="primary" size="large" @click="router_to_main">
            Далее
            <icon-vektor-to-right class="main-page__vektor" />
          </a-button>
        </div>
      </div>
    </div>
  </the-page>
</template>

<script>
import store from '@/store';

export default {
  name: 'MainPage',

  components: {
    ThePage: () => import('@/components/page/ThePage.vue'),
    IconVektorToRight: () => import('@/assets/svg/icon-vektor-to-right.svg'),
  },
  props: {
    config: {
      type: Object,
      default: () => {
      },
    }
  },
  computed: {
    pageId() {
      return 'main-page';
    },
    name() {
      return store?.state?.userFio;
    },
    menuRole(){
      return store?.state?.user?.menuRole
    },
    version() {
      return process.env.VUE_APP_FE_VERSION || '2.1';
    },
  },
  created() {
    this.getPath()
    setTimeout(this.getPath, 500)
  },
  methods: {
    getPath() {
      const el = this.config.sidebar.children[0].children[0]
      this.router_name = el.title
      this.path = `/${el.type}/${el.code}`
    },
    router_to_main() {
      this.$router.push({path: this.path})
    },
  },
};
</script>

<style lang="scss" scoped>
.main-page {
  height: 80vh;
  display: flex;
  align-items: center;

  &__emblem {
    width: 76px;
    height: 90px;
    background-image: url('./../assets/emblem.jpg');
  }

  &__content {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  &__vektor {
    height: 10px;
    width: 10px;
    margin-left: 8px;

    path {
      stroke: #ffffff;
    }
  }

  &__time {
    color: lighten(#243041, 55%);
  }

  &__block-logo {
    display: flex;
    align-items: center;
  }

  &__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 31px;
    border-radius: 6px;
  }

  &__text-header {
    &_blue {
      font-weight: 600;
      font-size: 24px;
      margin-bottom: 0;
      color: #366dbb;
      text-transform: uppercase;
      line-height: 0.8;
      word-spacing: -3px;
      letter-spacing: 3px;
    }

    &_black {
      font-weight: 600;
      font-size: 24px;
      line-height: 29px;
      color: #243041;
      word-spacing: 1px;
      text-transform: none;
      margin-bottom: 16px;
    }
  }

  &__text {
    margin: 0;

    &:first-child {
      font-size: 14px;
      color: #366dbb;
      text-transform: uppercase;
      font-weight: 400;
      line-height: 0.8;
    }

    &:last-child {
      font-weight: normal;
      font-size: 16px;
      line-height: 19px;
      color: #243041;
    }
  }

  &__block-logo-text {
    margin-left: 12px;
  }

  &__version, &__role  {
    position: absolute;
    color: #71829b;
    bottom: 45px;
    left: 69px;
    font-weight: 600;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    margin-bottom: 0;
  }
  &__role {
    bottom: 30px
  }

  &__block-text {
    &_big {
      margin-top: 23px;
      margin-bottom: 15px;
      line-height: 36px;
      color: #243041;
      font-weight: 600;
      font-size: 30px;
      max-width: 400px;
    }

    &_small {
      color: #243041;
      font-weight: normal;
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 0;
      max-width: 360px;
    }
  }

  &__block {
    height: 564px;
    width: 50%;
    background-color: #ffffff;
    box-shadow: 0px 5px 10px rgba(155, 171, 197, 0.1);
    border-radius: 8px;

    &:first-child {
      margin-right: 15px;
      padding-left: 69px;
      padding-top: 103px;
      padding-bottom: 45px;
      position: relative;
    }

    &:last-child {
      margin-left: 15px;
      padding-top: 190px;
      padding-left: 114px;
    }
  }
}
</style>
